import { useKeycloak } from '@react-keycloak/web';
import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useTranslation } from 'react-i18next';
import ModalFooter from '../Modal/Modal-footer/ModalFooter';
import Icons from '../../../configs/icon.config';
import Translate from '../Translate';
import formatBengaliNumber from '../../../utils/banglaNumber';

const THIRTY_MINS = 30 * 60 * 1000;
const ONE_MIN = 1 * 60 * 1000;

export default function UserIdleLogout() {
  const { keycloak } = useKeycloak();
  const { t } = useTranslation();
  const [remaining, setRemaining] = useState<number>(THIRTY_MINS);
  const [open, setOpen] = useState<boolean>(false);

  const onIdle = async () => {
    setOpen(false);
    localStorage.removeItem('MyBrac-admin');
    await keycloak?.logout();
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout: THIRTY_MINS,
    promptBeforeIdle: ONE_MIN,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const handleStillHere = () => {
    activate();
  };

  const seconds = remaining !== 1 ? 'seconds' : 'second';

  return (
    <Modal open={open} onCancel={handleStillHere} width={750} footer={null}>
      <div>
        <div className="text-center py-28">
          <h1 className="text-5xl block mb-5">{t('userIdlePopup.heading')}</h1>
          <p className="text-[2.2rem]">
            <Translate
              en={`You will be logged out automatically in ${remaining} ${seconds}`}
              bn={`আপনাকে আগামী ${formatBengaliNumber(
                remaining
              )} সেকেন্ড পর স্বয়ংক্রিয় ভাবে লগ-আউট করে দেওয়া হবে`}
            />
          </p>
        </div>
        <div>
          <ModalFooter
            key={1}
            buttonText={
              <Translate en="Stay in myBrac" bn="মাই-ব্র্যাকে থাকুন" />
            }
            buttonIcon={Icons.back}
            onCancel={handleStillHere}
          />
        </div>
      </div>
    </Modal>
  );
}
